module.exports = __webpack_public_path__ + "static/ChimeraA-41944a68338cb74983f582481a26d22a.gif";